import React from "react";
import ImageLoader from "./ImageUploader";
import ImgLabel from "@component/assure/ImgLabel";
import INavBar from "@component/INavBar";
import "./index.scss";
import { Button, Toast } from "antd-mobile";
import { getQueryParams, isEmpty } from "@src/util";
import CommonService from "@service/commonService";
import { goBack } from "@src/route";

type ArchiveEditStateType = {
  form: any;
};

export default class ArchiveEdit extends React.Component<
  any,
  ArchiveEditStateType
> {
  id: number;

  constructor(props: any) {
    super(props);

    const queryParams = getQueryParams();
    this.id = parseInt(queryParams.id);
    this.state = {
      form: {},
    };
  }

  getDetail() {
    CommonService.getArchiveDetail(this.id).then((rs) => {
      const form = {
        ...this.state.form,
        ...rs,
      };
      if (isEmpty(form.otherimgOssKeys)) {
        form.otherimgOssKeys = [];
      }
      if (isEmpty(form.driveImgOssKeys)) {
        form.driveImgOssKeys = [undefined, undefined];
      } else if (form.driveImgOssKeys.length == 1) {
        form.driveImgOssKeys.push(undefined);
      }
      if (isEmpty(form.addImgOssKeys)) {
        form.addImgOssKeys = [];
      }
      this.setState({ form });
    });
  }

  componentDidMount() {
    this.getDetail();
  }

  onSave() {
    const { form } = this.state;
    const sbForm = {
      id: this.id,
      // cusvehicleImg: form.cusvehicleimgOssKey?.id,
      // vehicleVinImg: form.vehiclevinimgOssKey?.id,
      // vehicleDashboardImg: form.vehicledashboardimgOssKey?.id,
      // vehicleImg: form.vehicleimgOssKey?.id,
      vehicleRegisterImg: form.vehicleRegisterImgOssKeys?.id,
      releasedMortgageImg: form.releasedMortgageImgOssKeys?.id,
      driveImg: form.driveImgOssKeys
        .filter((d: any) => !!d)
        .map((d: any) => d.id)
        .join(","),
      invoiceImg: form.invoiceImgOssKey?.id,
      otherImg: form.addImgOssKeys.map((d: any) => d.id).join(","),
    };
    CommonService.archiveSave(sbForm)
      .then((rs) => {
        Toast.show("保存成功！");
      })
      .catch((e) => {
        Toast.show(e);
      });
  }

  onSubmit() {
    //todo validate
    const { form } = this.state;
    // if (isEmpty(form.cusvehicleimgOssKey)) {
    // 	Toast.show('请上传客户与车的合影')
    // 	return;
    // }
    // if (isEmpty(form.vehiclevinimgOssKey)) {
    // 	Toast.show('请上传车架号照片')
    // 	return;
    // }
    // if (isEmpty(form.vehicledashboardimgOssKey)) {
    // 	Toast.show('请上传仪表盘照片')
    // 	return;
    // }
    // if (isEmpty(form.vehicleimgOssKey)) {
    // 	Toast.show('请上传整车照片')
    // 	return;
    // }
    if (
      isEmpty(form.driveImgOssKeys?.filter((d: any) => !!d)) ||
      form.driveImgOssKeys.filter((d: any) => !!d).length == 1
    ) {
      Toast.show("请上传行驶证正反面");
      return;
    }

    const sbForm = {
      id: this.id,
      // cusvehicleImg: form.cusvehicleimgOssKey?.id,
      // vehicleVinImg: form.vehiclevinimgOssKey?.id,
      // vehicleDashboardImg: form.vehicledashboardimgOssKey?.id,
      // vehicleImg: form.vehicleimgOssKey?.id,
      vehicleRegisterImg: form.vehicleRegisterImgOssKeys?.id,
      releasedMortgageImg: form.releasedMortgageImgOssKeys?.id,
      driveImg: form.driveImgOssKeys
        .filter((d: any) => !!d)
        .map((d: any) => d.id)
        .join(","),
      invoiceImg: form.invoiceImgOssKey?.id,
      otherImg: form.addImgOssKeys.map((d: any) => d.id).join(","),
    };
    CommonService.archiveSubmit(sbForm)
      .then((rs) => {
        Toast.show({
          content: "提交成功！",
          afterClose: () => {
            // 保存成功后返回列表页
            goBack();
          },
        });
      })
      .catch((e) => {
        Toast.show(e);
      });
  }

  render() {
    const { form } = this.state;

    const di = form.driveImgOssKeys || [];
    const df = di[0];
    const db = di[1];

    const otherImages = form.otherimgOssKeys || [];
    const olist: Array<any> =
      otherImages.length < 15 ? otherImages.concat([undefined]) : otherImages;

    return (
      <div className="archive">
        <INavBar title={`资料填写`} />
        <div className="archive-form">
          <div className="archive-info">
            {form.checkComment == 4 && <div>驳回原因：{form.checkComment}</div>}
            <div className="item">客户姓名:{form.insuredName}</div>
            <div className="item">手机号码:{form.mobile}</div>
          </div>
          <div className="archive-form-title1">归档要件：</div>
          {/* <div className="archive-form-title required">客户与车的合影（不能带口罩）</div>
				<div className="archive-form-img-box">
					<ImageLoader src={form.cusvehicleimgOssKey?.osskeySmall}
								 previewSrc={form.cusvehicleimgOssKey?.osskey}
								 onRemove={() => {
									 form.cusvehicleimgOssKey = undefined
									 this.setState({form})
								 }}
								 onChange={e => {
									 form.cusvehicleimgOssKey = e
									 this.setState({form})
								 }}
					>
						<ImgLabel type={'normal'}/>
					</ImageLoader>
				</div> */}
          {/* <div className="archive-form-title required">车架号照片</div>
				<div className="archive-form-img-box">
					<ImageLoader src={form.vehiclevinimgOssKey?.osskeySmall}
								 previewSrc={form.vehiclevinimgOssKey?.osskey}
								 onRemove={() => {
									 form.vehiclevinimgOssKey = undefined
									 this.setState({form})
								 }}
								 onChange={e => {
									 form.vehiclevinimgOssKey = e
									 this.setState({form})
								 }}
					>
						<ImgLabel type={'normal'}/>
					</ImageLoader>
				</div> */}
          {/* <div className="archive-form-title required">仪表盘照片</div>
				<div className="archive-form-img-box">
					<ImageLoader src={form.vehicledashboardimgOssKey?.osskeySmall}
								 previewSrc={form.vehicledashboardimgOssKey?.osskey}
								 onRemove={() => {
									 form.vehicledashboardimgOssKey = undefined
									 this.setState({form})
								 }}
								 onChange={e => {
									 form.vehicledashboardimgOssKey = e
									 this.setState({form})
								 }}
					>
						<ImgLabel type={'normal'}/>
					</ImageLoader>
				</div> */}
          {/* <div className="archive-form-title required">整车照片</div>
				<div className="archive-form-img-box">
					<ImageLoader src={form.vehicleimgOssKey?.osskeySmall}
								 previewSrc={form.vehicleimgOssKey?.osskey}
								 onRemove={() => {
									 form.vehicleimgOssKey = undefined
									 this.setState({form})
								 }}
								 onChange={e => {
									 form.vehicleimgOssKey = e
									 this.setState({form})
								 }}
					>
						<ImgLabel type={'normal'}/>
					</ImageLoader>
				</div> */}
          <div className="archive-form-title required">行驶证正反面</div>
          <div className="archive-form-img-box">
            <ImageLoader
              src={df?.osskeySmall}
              previewSrc={df?.osskey}
              onRemove={() => {
                form.driveImgOssKeys.splice(0, 1, undefined);
                this.setState({ form });
              }}
              onChange={(e) => {
                form.driveImgOssKeys.splice(0, 1, e);
                this.setState({ form });
              }}
            >
              <ImgLabel type={"normal"} />
            </ImageLoader>
            <ImageLoader
              src={db?.osskeySmall}
              previewSrc={db?.osskey}
              onRemove={() => {
                form.driveImgOssKeys.splice(1, 1, undefined);
                this.setState({ form });
              }}
              onChange={(e) => {
                form.driveImgOssKeys.splice(1, 1, e);
                this.setState({ form });
              }}
            >
              <ImgLabel type={"normal"} />
            </ImageLoader>
          </div>
          {/* <div className="archive-form-title">购置税发票</div>
				<div className="archive-form-img-box">
					<ImageLoader src={form.invoiceImgOssKey?.osskeySmall}
								 previewSrc={form.invoiceImgOssKey?.osskey}
								 onRemove={() => {
									 form.invoiceImgOssKey = undefined
									 this.setState({form})
								 }}
								 onChange={e => {
									 form.invoiceImgOssKey = e
									 this.setState({form})
								 }}
					>
						<ImgLabel type={'normal'}/>
					</ImageLoader>
				</div> */}
          <div className="archive-form-title required">摩托车登记证照片</div>
          <div className="archive-form-img-box">
            <ImageLoader
              src={form.vehicleRegisterImgOssKeys?.osskeySmall}
              previewSrc={form.vehicleRegisterImgOssKeys?.osskey}
              onRemove={() => {
                form.vehicleRegisterImgOssKeys = undefined;
                this.setState({ form });
              }}
              onChange={(e) => {
                form.vehicleRegisterImgOssKeys = e;
                this.setState({ form });
              }}
            >
              <ImgLabel type={"normal"} />
            </ImageLoader>
          </div>
          <div className="archive-form-title">解除抵押凭证</div>
          <div className="archive-form-img-box">
            <ImageLoader
              src={form.releasedMortgageImgOssKeys?.osskeySmall}
              previewSrc={form.releasedMortgageImgOssKeys?.osskey}
              onRemove={() => {
                form.releasedMortgageImgOssKeys = undefined;
                this.setState({ form });
              }}
              onChange={(e) => {
                form.releasedMortgageImgOssKeys = e;
                this.setState({ form });
              }}
            >
              <ImgLabel type={"normal"} />
            </ImageLoader>
          </div>
          <div className="archive-form-title">其他</div>
          <div className="archive-form-img-box">
            {olist.map((item, index) => {
              const key = item?.id || Math.random().toFixed(6);
              return (
                <ImageLoader
                  key={key}
                  src={item?.osskeySmall}
                  previewSrc={item?.osskey}
                  onChange={(e) => {
                    if (e) {
                      form.otherimgOssKeys[index] = e;
                      this.setState({ form });
                    }
                  }}
                  onRemove={() => {
                    form.otherimgOssKeys.splice(index, 1);
                    this.setState({ form });
                  }}
                >
                  <ImgLabel type={"normal"} />
                </ImageLoader>
              );
            })}
          </div>
          <div className="footer">
            <Button
              onClick={this.onSave.bind(this)}
              style={{
                backgroundColor: "#6291df",
                color: "#FFF",
                float: "right",
                padding: "8px 26px",
              }}
            >
              保存
            </Button>
            <Button
              onClick={this.onSubmit.bind(this)}
              style={{
                backgroundColor: "#6291df",
                color: "#FFF",
                float: "right",
                padding: "8px 26px",
              }}
            >
              提交
            </Button>
          </div>
        </div>
      </div>
    );
  }
}
